module.exports = __webpack_public_path__ + "img/scripted-rest.20590f8b.svg";